/* Zubehör-Zeile im Warenkorb (B5, 03.10.2026) – Klick-Handler für snippets/warenkorb-zubehoer.liquid.
   Liegt hier statt im Snippet, weil der Warenkorb-Drawer per innerHTML nachgeladen wird. */
(function () {
    // Capture-Phase: Drawer und Theme stoppen teils die Weitergabe von Klicks
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-wz-dazu]');
      if (!b || b.disabled) return;
      e.preventDefault(); e.stopPropagation();
      b.disabled = true; b.textContent = '…';
      var mini = document.querySelector('mini-cart');
      var seite = !!b.closest('.wz--seite');
      var sections = !seite && mini && mini.getSectionsToRender ? mini.getSectionsToRender().map(function (s) { return s.id; }) : [];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-wz-dazu')), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Fehler');
          if (seite) { window.location.reload(); return; }
          if (mini && mini.renderContents && res.j.sections) mini.renderContents(res.j);
          else window.location.reload();
        })
        .catch(function (err) {
          b.disabled = false; b.textContent = 'Dazulegen';
          var box = b.closest('[data-wz]');
          var m = box.querySelector('.wz__fehler') || box.appendChild(document.createElement('p'));
          m.className = 'wz__fehler'; m.textContent = err.message;
        });
    }, true);
  })();
